import React from 'react'

export const TextWrapper = () => {
  return (
    <div tabindex="0" className="text-wrapper">
            <h1>Hi!</h1>
            <h2>Welcome to this short travel survey!</h2>
            <p>Hopefully all the countrys will soon open up and we can start living again.</p>
            <p>For alot of people living is travling, how do you like to travel?</p>
            <p>Please take a minute to fill out this survey.</p> 
          </div>
  )
}